import React from 'react'
import ButtonClose from '../../atoms/button-close/button-close'

const ModalPreGameCard = ({ children, onCancel }) => {
  return (
    <div className="f-modal-pre-game__card">
      <ButtonClose onClick={onCancel} />
      <div className="f-modal-pre-game__card__body">{children}</div>
    </div>
  )
}

export default ModalPreGameCard
